import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Database14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4 5.5C4.55228 5.5 5 5.05228 5 4.5C5 3.94772 4.55228 3.5 4 3.5C3.44772 3.5 3 3.94772 3 4.5C3 5.05228 3.44772 5.5 4 5.5Z'
      fill='currentColor'
    />
    <path d='M11 3.75H7V5.25H11V3.75Z' fill='currentColor' />
    <path
      d='M5 9.5C5 10.0523 4.55228 10.5 4 10.5C3.44772 10.5 3 10.0523 3 9.5C3 8.94772 3.44772 8.5 4 8.5C4.55228 8.5 5 8.94772 5 9.5Z'
      fill='currentColor'
    />
    <path d='M7 8.75H11V10.25H7V8.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.394128 7.1553C0.298216 6.97813 0.25 6.78022 0.25 6.58333V2.83333C0.25 2.00649 0.897526 1.25 1.75 1.25H12.25C13.1025 1.25 13.75 2.00649 13.75 2.83333V6.58333C13.75 6.78022 13.7018 6.97813 13.6059 7.1553C13.7013 7.36832 13.75 7.60042 13.75 7.83333V11.5833C13.75 12.2011 13.2559 12.75 12.625 12.75H1.375C0.744069 12.75 0.25 12.2011 0.25 11.5833V7.83333C0.25 7.60042 0.29874 7.36832 0.394128 7.1553ZM1.75 3C1.75 2.73649 2 2.75 2.01001 2.73649L11.99 2.73649C12 2.75 12.25 2.73649 12.25 3V6.25H1.75V3ZM2 7.75C1.98999 7.76351 1.75 7.75 1.75 8V11.25H12.25V8C12.25 8 12.25 7.73649 11.99 7.73649L2 7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Database14.displayName = 'Database14';
export default Database14;
